// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/student.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_account_role } from "./account_role_pb.js";
import { file_studyo_today_schools_v1_resources_external_source } from "./external_source_pb.js";
import { file_studyo_today_schools_v1_resources_student_stats } from "./student_stats_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/student.proto.
 */
export const file_studyo_today_schools_v1_resources_student = /*@__PURE__*/
  fileDesc("Ci9zdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvc3R1ZGVudC5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIqsDCgdTdHVkZW50EhIKCmFjY291bnRfaWQYASABKAkSEQoJc2Nob29sX2lkGAIgASgJEkoKD2V4dGVybmFsX3NvdXJjZRgDIAEoCzIxLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5FeHRlcm5hbFNvdXJjZRIRCglmdWxsX25hbWUYBCABKAkSFQoNZW1haWxfYWRkcmVzcxgFIAEoCRITCgtwaWN0dXJlX3VybBgGIAEoCRI+CgVzdGF0cxgHIAEoCzIvLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5TdHVkZW50U3RhdHMSDwoHdXNlcl9pZBgIIAEoCRISCgpwbGFubmVyX2lkGAkgASgJEiUKHXBsYW5uZXJfZXh0ZXJuYWxfc291cmNlX25hbWVzGAogAygJEiQKHGlzX3BsYW5uZXJfYWNjZXNzX2F1dGhvcml6ZWQYCyABKAgSPAoEcm9sZRgMIAEoDjIuLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5BY2NvdW50Um9sZUIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_schools_v1_resources_account_role, file_studyo_today_schools_v1_resources_external_source, file_studyo_today_schools_v1_resources_student_stats]);

/**
 * Describes the message studyo.today.schools.v1.resources.Student.
 * Use `create(StudentSchema)` to create a new message.
 */
export const StudentSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_student, 0);

